module.exports = "/assets/c72c2d4340cb3d6a8bb3c3db6be5a0f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/db.svg
// module id = 3594
// module chunks = 0